import React, { Suspense, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TestimonialBox from './testimonialBox';
import { FaPlay } from "react-icons/fa6";
import { CgClose } from "react-icons/cg";

import testiThumbImg1 from '../../assets/images/testimonials/maxres2-1.jpg'
import testiThumbImg2 from '../../assets/images/testimonials/maxres2-2.jpg'
import testiThumbImg3 from '../../assets/images/testimonials/maxres2.jpg'

const Testimonial = () => {

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [currentVideo, setCurrentVideo] = useState('');
  
    const handleVideoClick = (videoSrc) => {
      setCurrentVideo(videoSrc);
      setIsPopupVisible(true);
    };
  
    const closePopup = () => {
      setIsPopupVisible(false);
      setCurrentVideo('');
    };

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1.2,
        center: true,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
    };

    return (
        <>
            {/* testimonial popup */}
            {isPopupVisible && (
                <div className="testimonialPopup">
                    <div className="closeTestimonialPopup" onClick={closePopup}>
                        <CgClose />
                    </div>
                    <div className="testimonialPopupVideo">
                        <iframe
                        src={currentVideo}
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                        title="Testimonial Video"
                        ></iframe>
                    </div>
                </div>
            )}
            {/* testimonial popup close */}

            <section id='testimonial'>
                <div className="container">
                    <h2 className='title'>What Students talk about us</h2>
                    <p className="desc">Get a look at what our students have to say about their experience with us.</p>
                </div>
                <div className="testimonialMain">
                    <Slider {...settings}>
                        <Suspense fallback={<div>Loading...</div>}>
                            <TestimonialBox testimonialDescription="I recently had the pleasure of being tutored PTE by Neethu Ma’am. I wanted to share some of my positive experiences. She demonstrated exceptional knowledge of the PTE exam structure and provided insightful strategies that were very useful for me. Her teaching style was clear and engaging, making complex concepts easy to understand. Moreover, she was always patient and encouraging, which helped me to boost up my confidence. Thank you" testimonialName="Jessin sam" testimonialDesignation="Student" />
                        </Suspense>
                        <Suspense fallback={<div>Loading...</div>}>
                            <TestimonialBox testimonialDescription="The classes were extremely informative and helpful for me . The training was very useful. Relevant theory explained during the session was particularly helpful for me. Revathy ma’am, you were able to provide us with very good practical techniques. Thank you for showing us good techniques." testimonialName="Jijy Sharon" testimonialDesignation="Student" />
                        </Suspense>
                    </Slider>
                </div>
                <div className="videoTestimonial">
                    <Slider {...settings}>
                        <div
                        className="videoTestimonialBox"
                        onClick={() => handleVideoClick("https://www.youtube.com/embed/dCWw3IQGdiY")}
                        >
                        <div className="videoTestimonialBoxThumbnail">
                            <img src={testiThumbImg1} alt="" />
                            <div className="videoTestimonialBoxThumbnailIcon">
                            <FaPlay />
                            </div>
                        </div>
                        </div>
                        <div
                        className="videoTestimonialBox"
                        onClick={() => handleVideoClick("https://www.youtube.com/embed/B6YMnXAngYs")}
                        >
                        <div className="videoTestimonialBoxThumbnail">
                            <img src={testiThumbImg2} alt="" />
                            <div className="videoTestimonialBoxThumbnailIcon">
                            <FaPlay />
                            </div>
                        </div>
                        </div>
                        <div
                        className="videoTestimonialBox"
                        onClick={() => handleVideoClick("https://www.youtube.com/embed/TyFQmjPvPGo")}
                        >
                        <div className="videoTestimonialBoxThumbnail">
                            <img src={testiThumbImg3} alt="" />
                            <div className="videoTestimonialBoxThumbnailIcon">
                            <FaPlay />
                            </div>
                        </div>
                        </div>
                    </Slider>
                    </div>
            </section>
        </>
    );
};

export default Testimonial;
